import { PRODUCTION, DEVELOPMENT, API_INTEL_URL } from "./const";
import { isEmpty } from "lodash";

export function intelUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const INTEL_API_URL = !!process.env.REACT_APP_API_INTEL_URL && process.env.REACT_APP_API_INTEL_URL !== "" ? process.env.REACT_APP_API_INTEL_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return API_INTEL_URL;
      case PRODUCTION:
        return INTEL_API_URL;
      default:
        return API_INTEL_URL;
    }
  } else {
    return API_INTEL_URL;
  }
}

export const getIntelApiUrl = (path) => {
  return `${intelUrl()}/${path}`;
};
